import { useContext, useEffect, useState } from "react";
import cardStyles from "../styles/Card.module.css";
import buttonStyles from "../styles/Button.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { GlobalContext } from "../App";
import { useAuth } from "react-oidc-context";
import { createFAQ, fetchFAQById, updateFAQ } from "../api";
import { FAQ } from "../types";

export default function AddOrEditFAQView() {
    const { site, id } = useParams<{site:string, id:string}>();

    const [question, setQuestion] = useState("")
    const [answer, setAnswer] = useState("")
    const [originalQuestion, setOriginalQuestion] = useState("")
    const [originalAnswer, setOriginalAnswer] = useState("")

    const navigate = useNavigate();

    // alert modal state
    const [alertModalOpen, setAlertModalOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    const {globalSite, setSite} = useContext(GlobalContext);
    const auth = useAuth();

    useEffect(() => {
        if (globalSite === undefined || globalSite === "") {
            if (typeof auth.user?.profile.site === "string") {
                setSite(auth.user?.profile.site)
            } else if (typeof site === "string") {
                setSite(site)
            }
        }
    }, [globalSite, site, auth.user?.profile.site, setSite])

    useEffect(() => {
        if (id) {
            fetchFAQById(globalSite, parseInt(id)).then((f) => {
                setOriginalQuestion(f.question)
                setOriginalAnswer(f.answer)
            })
        }
    })

    // modal open/close
    const openAlertModal = (text:string) => {
        setAlertMessage(text);
        setAlertModalOpen(true);
    }
    const closeAlertModal = () => {
        setAlertModalOpen(false);
        setAlertMessage("");
    }

    function displayOriginalQuestion() {
        if (id) {
            return (
                <div>
                    Original Question: {originalQuestion}
                </div>
            )
        }
    }

    function displayOriginalAnswer() {
        if (id) {
            return (
                <div>
                    Original Answer: {originalAnswer}
                </div>
            )
        }
    }

    function save() {
        if (id) {
            return update()
        }
        console.log("save")

        if (question === undefined || question.trim() === "") {
            openAlertModal("Please enter a question");
            return
        }
        if (answer === undefined || answer.trim() === "") {
            openAlertModal("Please enter an answer");
            return
        }

        const faq:FAQ = { id: parseInt(id ?? "-1"), question: question, answer: answer };

        // create
        createFAQ(globalSite, faq)
        navigate(-1)
    }

    function update() {
        console.log("update")

        if ((question === undefined || question.trim() === "") && (answer === undefined || answer.trim() === "")) {
            openAlertModal("Please enter atleast either an update question or answer")
            return;
        }

        const faq:FAQ = {
            id: parseInt(id ?? "-1"),
            question: question.trim() === "" ? originalQuestion : question,
            answer: answer.trim() === "" ? originalAnswer: answer
        };

        updateFAQ(globalSite, faq);
        navigate(-1)
    }

    return (
        <div
            className={cardStyles.card}
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%"
        }}>
            <h2>Add FAQ</h2>
            {displayOriginalQuestion()}
            <input 
                id="faqQuestion"
                type="text"
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
                placeholder="New quesiton"
                style={{
                    width: "100%",
                    padding: "8px 8px",
                    fontSize: "1rem",
                    borderRadius: 4,
                    border: "1px solid #ccc",
                }}
            />
            {displayOriginalAnswer()}
            <input 
                id="faqAnswer"
                type="text"
                value={answer}
                onChange={(e) => setAnswer(e.target.value)}
                placeholder="New answer"
                style={{
                    width: "100%",
                    padding: "8px 8px",
                    fontSize: "1rem",
                    borderRadius: 4,
                    border: "1px solid #ccc",
                }}
            />
            <div style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                gap: "8px",
                marginTop: "8px"
            }}>
                <button
                    className={`${buttonStyles.button} ${buttonStyles.primary}`}
                    onClick={save}
                >Save</button>
                <button
                    className={`${buttonStyles.button} ${buttonStyles.close}`}
                    onClick={() => navigate(-1)}
                >Cancel</button>
            </div>
        </div>
    )
}
